<template>
    <div>
		<Card>
			<Row :gutter="16">
			    <Col span="24">
			    <div class="global-tool-bar">
			        <div class="left-bar">
			            <span class="title">订购次数统计分析</span>
			            <DatePicker type="daterange"
			                v-model="selectDates"
			                size="small"
			                transfer
			                placement="bottom-end"
			                placeholder="选择期初和期末时间"
			                style=" margin-left:4px;width: 200px"
			                @on-change="onDateChange"></DatePicker>
			            <Select v-model="selectedSeedFarmUuid"
			                style="width:200px;margin-left:5px;"
			                size="small"
			                placeholder="选择苗场"
			                @on-change="onSeedFarmChange"
			                filterable
			                clearable>
			                <Option v-for="item in seedFarmList"
			                    :value="item.seedFarmUuid"
			                    :key="item.seedFarmUuid">{{ item.seedFarmCode + ' '  + item.seedFarmName }}</Option>
			            </Select>
			
			            <Select v-model="selectedProductUuid"
			                style="width:200px;margin-left:5px;"
			                size="small"
			                placeholder="选择商品"
			                filterable
			                clearable>
			                <Option v-for="item in productList"
			                    :key="item.productUuid"
			                    :value="item.productUuid">{{ item.productCode + '-' + item.productName }}</Option>
			            </Select>
			
			            <Button type="success"
			                size="small"
			                class="btns"
			                icon="ios-stats"
			                @click="beginStat()">统计</Button>
			        </div>
			        <div class="right-bar">
			
			        </div>
			    </div>
			    </Col>
			</Row>
			
			
			
			<Row :gutter="16">
				<Col span="24">		
					<Table ref="mainTable"
					    :columns="mainTable.columns"
					    size="small"
					    :data="mainTable.data"
					    :loading="mainTable.loading"
					    :height="mainTable.tableHeight"
					    stripe
					    border />
					<Modal v-model="customerStatCountModal.show"
						:width="1000"
						footer-hide>
						<Spin v-if="customerStatCountModal.innerSpin"
							size="large"
							fix></Spin>
						<div slot="header">
							<span style="font-weight:bold;font-size: 14px;">订购次数统计</span>
						</div>
						<CustomerStatBar ref="customerStatBar"
							style="height: 400px;width:100%;"
							:value="customerStatCountModal.barData"
							:text="customerStatCountModal.barTitle" />
					</Modal>
				</Col>
			</Row>
		</Card>
    </div>
	
</template>

<script>
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { getOrderCountAnalyze } from '@/api/modules/stat-analyze/customer-analyze';
import CustomerStatBar from '@/components/charts/customer-stat-bar.vue';
import { getThisMonthStart, getTodayDateString } from '@/libs/logic';
import { getSeedFarmList } from '@/api/modules/system-management/seedFarm-management';
import { getSeedFarmProductList } from '@/api/modules/system-management/seedFarm-management';

export default {
    name: 'customerOrderCount',
    components: {
        StandPaginationTable,
        CustomerStatBar
    },
    data() {
        return {
            innerSpin:false,
            selectDates: [],
            selectedSeedFarmUuid: '',
            seedFarmList: [],
            productList: [],
            selectedProductUuid: '',
            mainTable: {
                columns: [],
                data: [],
                loading: false,
                tableHeight: 100
            },
            customerStatCountModal:{
                show: false,
                innerSpin: false,
                barTitle: '',
                barData: {}
            }
        };

    },
    mounted() {
        let beginDate = this.getThisMonthStart();
        let endDate = this.getTodayDateString();
        this.selectDates = [beginDate, endDate];
        this.getAllSeedFarm();
		
        this.mainTable.tableHeight
            = window.innerHeight
            - this.$refs.mainTable.$el.offsetTop
            - 210;
    },
    methods: {
        getTodayDateString,
        getThisMonthStart,
        queryStat(postData) {
            this.mainTable.loading = true;
            getOrderCountAnalyze(postData).then(res => {
                this.mainTable.loading = false;
                if (res.code === 0) {
                    this.makeNewField(res.data.columns);
                    this.mainTable.data = res.data.records;
                }
            });
        },
        makeNewField(columns) {
            this.mainTable.columns = [{ title: '周次', key: 'week', width: 60, align: 'center', fixed: 'left' }];
            columns.forEach(c => {
                const memberColumn = {
                    title: c,
                    key: c,
                    align: 'center',
                    width: 80,
                    renderHeader: (h, { column, index }) => {
					    return h('div',
					        [
					            h('span', {}, column.title),
					            h('icon', {
					                props: {
					                    type: 'md-stats',
					                    size: 18,
					                    color: 'red'
					                },
					                style: {
					                    marginLeft: '8px'
					                },
					                on: {
					                    click: () => {
					                        this.showChart(column);
					                    }
					                }
					
					            })
					        ]
					    );
                    }
                };
                this.mainTable.columns.push(memberColumn);
            });
        },
        showChart(column) {
		
		    this.customerStatCountModal.show = true;
		    this.customerStatCountModal.innerSpin = true;
		    let barData = {};
		    for (let i = 0; i < this.mainTable.data.length - 1; i++) {
		        const e = this.mainTable.data[i];
		        barData[e['week']] = e[column.key];
		    }
		    this.customerStatCountModal.barTitle = column.title;
		    this.customerStatCountModal.barData = barData;
		    this.customerStatCountModal.innerSpin = false;
		    this.$refs.customerStatBar.init();
        },
        getAllSeedFarm() {
		    this.innerSpin = true;
		    let tempSearch = search.getSearchParams({ closeAllConditions: true });
		    getSeedFarmList(tempSearch).then(res => {
		        this.innerSpin = false;
		        if (res.code === 0) {
		            this.seedFarmList = res.data.records;
		        }
		    });
        },
        onSeedFarmChange() {
		    this.innerSpin = true;
		    getSeedFarmProductList({ seedFarmUuid: this.selectedSeedFarmUuid }).then(res => {
		        this.innerSpin = false;
		        if (res.code === 0) {
		            this.productList = res.data.productList;
		        }
		    });
        },
        onDateChange(e) {
		    this.selectDates = e;
        },
        onClickTab(e) {
		    this.$nextTick(() => {
		        this.beginStat();
		    });
        },
        beginStat(){
            let postData = {
			    beginDate: this.selectDates[0],
			    endDate: this.selectDates[1],
			    productUuid: this.selectedProductUuid
            };
            this.queryStat(postData);
        }
    }
};
</script>

<style scoped>
</style>
